import {observer} from "mobx-react";
import styled from "styled-components";
import FloatAskIco from  "/public/assets/icons/float-ask-icon.png"
import FloatApplyIco from "/public/assets/icons/float-apply-icon.png"
import FloatSubscribe from "/public/assets/icons/float-subscribe-icon.png"
import {SIZES} from "@/components/constants";
import {useEffect} from "react";
import {useStore} from "@/store";
import {useRouter} from "next/navigation";

const FloatMenu = observer(() => {
    const {contentStore, navigationStore, floatAreaStore} = useStore();
    const router = useRouter();
    useEffect(() => {
        contentStore.setFloatFormMenu(navigationStore.navigateList);
    }, []);
    return(
        <FloatMenuWrap>
            {
                contentStore.floatContactMenu && contentStore.floatContactMenu.length > 0 &&
                <div className={"menu-items"}>
                    <div className={"tit-wrap"}>
                        <div className={"icon-wrap ask"}>
                            <img src={FloatAskIco?.src} alt={"문의하기 아이콘"}/>
                        </div>
                        <div className={"tit"}>문의하기</div>
                    </div>
                    <div className={"menu-items-list"}>
                        {
                            contentStore.floatContactMenu.map((item, idx) =>
                                <div
                                    className={"list-items"} key={idx}
                                    onClick={()=>{
                                        floatAreaStore.setFloatingClear();
                                        router.push(`/homepage/form?menu-id=${item.menuId}`);
                                    }}
                                >
                                    {item.title}
                                </div>
                            )
                        }
                    </div>
                </div>
            }
            {
                contentStore.floatApplyMenu && contentStore.floatApplyMenu.length > 0 &&
                <div className={"menu-items"}>
                    <div className={"tit-wrap"}>
                        <div className={"icon-wrap apply"}>
                            <img src={FloatApplyIco?.src} alt={"신청하기 아이콘"}/>
                        </div>
                        <div className={"tit"}>신청하기</div>
                    </div>
                    <div className={"menu-items-list"}>
                        {
                            contentStore.floatApplyMenu.map((item, idx) =>
                                <div className={"list-items"} key={idx}
                                    onClick={() => {
                                        floatAreaStore.setFloatingClear();
                                        router.push(`/homepage/form?menu-id=${item.menuId}`);
                                    }}
                                >
                                    {item.title}
                                </div>
                            )
                        }
                    </div>
                </div>
            }
            <div className={"menu-items"}>
                <div className={"tit-wrap"}>
                    <div className={"icon-wrap subscribe"}>
                        <img src={FloatSubscribe?.src} alt={"구독하기 아이콘"}/>
                    </div>
                    <div className={"tit"}>구독하기</div>
                </div>
                <div className={"menu-items-list"}>
                    <div className={"list-items"}
                         onClick={() => {
                             floatAreaStore.setFloatingClear();
                             router.push(`/homepage/news?menu-id=691301d3bb6c9c96a4d5866d`);
                         }}
                    >eNews letter</div>
                </div>
            </div>
        </FloatMenuWrap>
    )
});
const FloatMenuWrap = styled.div`
    padding: 60px 130px 60px 60px;
    width: 100%;
    height: 100%;
    overflow: auto;

    .menu-items {
        display: flex;
        align-items: start;
        border-top: 2px solid #E6E6E6;
        width: 100%;
        padding-top: 30px;
        margin-top: 60px;
        gap: 60px;
        .tit-wrap{
            display: flex;
            align-items: center;
            width: 168px;
            flex-shrink: 0;
            gap: 20px;
            .icon-wrap{
                width: 61px;
                &.apply{
                    width: 64px;
                }
                &.subscribe{
                    width: 63px;
                }
            }
            .tit{
                font-weight: 700;
                font-size: 24px;
                line-height: 36px;
                letter-spacing: -0.02em;
                color: #4939B1;
            }
        }
        .menu-items-list{
            .list-items{
                font-weight: 400;
                font-size: 18px;
                margin-top: 25px;
                color: #333333;
                cursor: pointer;
                &:first-child{
                    margin: 0;
                }
                &:hover{
                    font-weight: 600;
                }
            }
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        padding: 0 16px 120px;
        justify-content: start;
        margin-top: 35px;
        .menu-items{
            padding: 16px 16px 0;
            margin-top: 30px;
            gap: 40px;
            .tit-wrap{
                display: flex;
                align-items: start;
                flex-direction: column;
                width: 68px;
                flex-shrink: 0;
                gap: 20px;
                .icon-wrap{
                    order: 1;
                    width: 64px;
                    &.apply{
                        width: 64px;
                    }
                    &.subscribe{
                        width: 63px;
                    }
                }
                .tit{
                    font-weight: 700;
                    font-size: 20px;
                    line-height: 30px;
                    letter-spacing: -0.02em;
                    color: #4939B1;
                }
            }
            .menu-items-list{
                .list-items{
                    font-weight: 400;
                    font-size: 16px;
                    margin-top: 20px;
                    &:hover{
                        font-weight: 400;
                    }
                }
            }
        }
    }
`
export default FloatMenu;








